import { useParams } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';
import { FormikHelpers } from 'formik';
import { useSnackbar } from 'notistack';

import { useFormMutation } from 'mutations/useFormMutation';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { formatInitialRegrasValidacaoData } from 'pages/compra/configuracao-pedido/hooks';
import { ConfigPedidoRegrasValidacao } from 'pages/compra/configuracao-pedido/types';

export function useMutateRegrasValidacao() {
    const { activeStep, setActiveStepSaved } = useConfigPedidoStepContext();
    const { mutate, isLoading } = useFormMutation();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const reactQuery = useQueryClient();

    const onSubmit = (values: ConfigPedidoRegrasValidacao, formik: FormikHelpers<ConfigPedidoRegrasValidacao>): void => {
        values.idConfigPedido = Number(id);
        values.peOferta = values.fgUtilizaDescontoCadastroLoja ? null : values.peOferta ?? 0;
        values.vlBaseFreteGratis = values.fgUtilizaVlBaseFreteGratis ? values.vlBaseFreteGratis : null;

        mutate(
            {
                url: '/gestao/configpedidoregravalidacao',
                idField: activeStep.fgSaved ? 'idConfigPedidoRegraValidacao' : '',
                formData: values,
                formik,
                preventRedirect: true,
                preventSnack: true,
            },
            {
                onSuccess: ({ data }: any) => {
                    enqueueSnackbar('Regras de Validação salvo com sucesso', { variant: 'success' });

                    setActiveStepSaved();

                    reactQuery.setQueryData(['config-pedido-regras-validacao', id], formatInitialRegrasValidacaoData(data.data));
                },
            },
        );
    };

    return { onSubmit, isLoading };
}
